import Events from '../events'
import EventBus from '../event-bus'
import { LogoTracker, LTEvents } from '~/lib/events/tracker'

/**
 * @param {string | null | undefined} value
 * @returns {string}
 */
const sanitizeString = value => (value ? value.toLowerCase().trim() : '')

/**
 * @param {string[]} strings
 * @returns {string[]}
 */
const sanitizeStrings = values => {
  const sanitizedStrings = values.map(sanitizeString)
  return [...new Set(sanitizedStrings)]
}

/**
 * Trackes a user selecting 0 or more color themes during the enhanced flow.
 * Themes will be de-deuplicated, normalized, and sanitized prior to being
 * tracked.
 *
 * @param {string[]} colorThemes
 */
const handleColorThemesSelected = colorThemes => {
  const themesToTrack = sanitizeStrings(colorThemes)

  themesToTrack.forEach(theme => {
    EventBus.$emit(Events.AnalyticsGA4Event, {
      event: 'enhanced_flow',
      color_theme_id: theme,
    })

    EventBus.$emit(Events.EcommerceSelectContent, {
      type: 'color_theme',
      id: theme,
    })
  })
}

/**
 * Handles tracking a set of font styles a user has selected.
 *
 * @param {string[]} fontStyles
 */
const handleFontStylesSelected = fontStyles => {
  const stylesToTrack = sanitizeStrings(fontStyles)

  stylesToTrack.forEach(style => {
    EventBus.$emit(Events.AnalyticsGA4Event, {
      event: 'enhanced_flow',
      font_style_id: style,
    })

    EventBus.$emit(Events.EcommerceSelectContent, {
      type: 'font_style',
      id: style,
    })
  })
}

/**
 * Tracks when a user has selected a logo type
 * @param {string} logoType
 */
const handleLogoTypeSelected = logoType => {
  EventBus.$emit(Events.EcommerceSelectContent, {
    type: 'logo_type',
    id: logoType,
  })

  EventBus.$emit(Events.AnalyticsGA4Event, {
    event: 'enhanced_flow',
    logo_type: logoType,
  })
}

/**
 * Tracks the keywords that a user has selected.
 * @param {string[]} keywords
 */
const handleKeywordsSelected = keywords => {
  const keywordsToTrack = sanitizeStrings(keywords)

  keywordsToTrack.forEach(keyword => {
    EventBus.$emit(Events.EcommerceSelectContent, {
      type: 'keyword',
      id: keyword,
    })

    EventBus.$emit(Events.AnalyticsGA4Event, {
      event: 'enhanced_flow',
      keyword_id: keyword,
    })
  })
}

EventBus.$on(Events.EnhancedFlowColorThemesSelected, handleColorThemesSelected)
EventBus.$on(Events.EnhancedFlowFontStylesSelected, handleFontStylesSelected)
EventBus.$on(Events.EnhancedFlowLogoTypeSelected, handleLogoTypeSelected)
EventBus.$on(Events.EnhancedFlowKeywordsSelected, handleKeywordsSelected)
